import orderBy from 'lodash/orderBy';

// src/hooks/useSort.ts
var useSort = (sortId) => {
  const handleOnSort = (array, sortOption) => {
    return sortOption ? orderBy(
      array,
      [
        (item) => typeof (item == null ? void 0 : item[sortId]) === "string" ? item == null ? void 0 : item[sortId].toLowerCase() : item == null ? void 0 : item[sortId]
      ],
      [sortOption]
    ) : array;
  };
  return handleOnSort;
};
var useSort_default = useSort;

export { useSort_default };
